import React, { useState, useEffect } from 'react';
import { Card, Col, Modal, Row } from 'react-bootstrap';
import { Pie, PieChart, Cell } from 'recharts';
import Select from 'react-select';
import { CloudUpload } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import mock from './mock.json';
import FiterAPI from '../../fiterAPI';
import AbstentionsModal from '../../Components/Modal/AbstentionsModal';
import SelfManagmentModal from './components/SelfManagmentModal';

export default function GeneralPanel() {
  const [data, setData] = useState([]);
  const [monthFilter, setMonthFilter] = useState('');
  const [selectedMonth, setSelectedMonth] = useState({});
  const [selectedYear, setSelectedYear] = useState({});
  const [showEvasionModal, setShowEvasionModal] = useState();
  const [institutionId, setInstitutionId] = useState('');

  const [showUploadSheetModal, setShowUploadSheetModal] = useState(false);
  const [institutionToUpdate, setInstitutionToUpdate] = useState('');

  useEffect(() => {
    async function fetchData() {
      const _data = await FiterAPI.getGeneralData(monthFilter);
      setData(_data);
    }
    fetchData();
  }, [monthFilter]);

  const monthsList = [
    { label: 'Jan', value: '01' },
    { label: 'Fev', value: '02' },
    { label: 'Mar', value: '03' },
    { label: 'Abr', value: '04' },
    { label: 'Mai', value: '05' },
    { label: 'Jun', value: '06' },
    { label: 'Jul', value: '07' },
    { label: 'Ago', value: '08' },
    { label: 'Set', value: '09' },
    { label: 'Out', value: '10' },
    { label: 'Nov', value: '11' },
    { label: 'Dez', value: '12' }
  ];

  const yearsList = [
    { label: '2020', value: '2020' },
    { label: '2021', value: '2021' },
    { label: '2022', value: '2022' },
    { label: '2023', value: '2023' }
  ];

  const handleMonthChange = e => {
    setSelectedMonth(e);
    if (selectedYear.value)
      setMonthFilter(`${e.value}-01-${selectedYear.value}`);
  };

  const handleYearChange = e => {
    setSelectedYear(e);

    if (selectedMonth.value)
      setMonthFilter(`${selectedMonth.value}-01-${e.value}`);
  };

  function getChartData(rawData) {
    const chartData = [
      { name: 'Respondentes', value: rawData?.respondents },
      { name: 'Abstenções', value: rawData?.abstentions }
    ];
    return chartData;
  }

  function handleShowEvasionList(institution) {
    setInstitutionId(institution);
    setShowEvasionModal(true);
  }

  const COLORS = ['#0088FE', '#FF8042', '#FFBB28', '#FF8042'];

  function handlerShowUploadSheetModal(institution) {
    setInstitutionId(institution);
    setShowUploadSheetModal(true);
  }

  return (
    <>
      <AbstentionsModal
        getAbstentions={FiterAPI.getAbstentions}
        show={showEvasionModal}
        setShow={setShowEvasionModal}
        institution={institutionId}
        monthFilter={monthFilter}
      />
      <SelfManagmentModal
        institutionId={institutionId}
        show={showUploadSheetModal}
        setShow={setShowUploadSheetModal}
      />
      <h2>Painel geral fiter</h2>
      <Row>
        <Col className="mt-3 col-md-2">
          <Select
            value={selectedMonth}
            onChange={handleMonthChange}
            options={monthsList}
            className="select-filter"
            placeholder="Escolha o mês."
          />
        </Col>
        <Col className="mt-3 col-md-2">
          <Select
            value={selectedYear}
            onChange={handleYearChange}
            options={yearsList}
            className="select-filter"
            placeholder="Escolha o Ano"
          />
        </Col>
      </Row>

      <br />
      <Row>
        {data.map(inst => (
          <>
            <Col md={4}>
              <Card>
                <Card.Header
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  {' '}
                  <h5>{inst.institutionName}</h5>
                  <IconButton
                    onClick={() =>
                      handlerShowUploadSheetModal(inst.institutionId)
                    }
                    size="small"
                  >
                    <CloudUpload />
                  </IconButton>
                </Card.Header>
                <Card.Body>
                  <ul>
                    <li>
                      {' '}
                      Respondentes: {inst.respondents} |{' '}
                      {Number(
                        inst.respondents / (inst.respondents + inst.abstentions)
                      ).toFixed(2) * 100}
                      %{' '}
                    </li>
                    <li
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleShowEvasionList(inst.institutionId)}
                    >
                      {' '}
                      Abstenções: {inst.abstentions}
                    </li>
                    <li> Total: {inst.respondents + inst.abstentions} </li>
                    <li>
                      {' '}
                      Evasão: {inst.evasion} |{' '}
                      {Number(inst.evasion / inst.respondents).toFixed(2) * 100}
                      %{' '}
                    </li>
                  </ul>
                  <PieChart width={300} height={250}>
                    <Pie
                      data={getChartData(inst)}
                      cx={120}
                      cy={100}
                      innerRadius={60}
                      outerRadius={80}
                      fill="#8884d8"
                      paddingAngle={1}
                      dataKey="value"
                    >
                      {getChartData(inst).map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                </Card.Body>
              </Card>
            </Col>
            <br />
          </>
        ))}
      </Row>
    </>
  );
}
